var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: _vm.classes, attrs: { "data-qa": "payment-tile" } },
    [
      _vm.hasLabels
        ? _c(
            "div",
            { staticClass: "gfu-payment-tile__labels" },
            _vm._l(_vm.labels, function (label) {
              return _c(
                "base-label",
                {
                  key: label.label,
                  attrs: {
                    theme: label.theme,
                    "data-qa": "payment-tile-label",
                  },
                },
                [_vm._v("\n            " + _vm._s(label.label) + "\n        ")]
              )
            }),
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "_cur-p _pa-3 _flexcol _gap-3",
          on: { click: _vm.onClick },
        },
        [
          _c(
            "div",
            { staticClass: "_flex _ai-c" },
            [
              _c("checkbox-field", {
                staticClass: "_mt-0 _mr-2",
                attrs: {
                  value: _vm.isSelected,
                  "show-label": false,
                  name: "paymentTile",
                  "checked-value": true,
                  type: "radio",
                },
              }),
              _vm._v("\n            " + _vm._s(_vm.name) + "\n            "),
              _vm.imageUrl
                ? _c("base-image", {
                    staticClass: "_ml-a",
                    attrs: {
                      src: _vm.imageUrl,
                      alt: _vm.name,
                      width: "34",
                      "data-qa": "payment-method-image",
                    },
                  })
                : _vm.iconName
                ? _c("base-icon", {
                    staticClass: "_ml-a _tc--accent",
                    attrs: {
                      name: _vm.iconName,
                      size: "lg",
                      "data-qa": "payment-method-image",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _vm.isSelected ? [_vm._t("default")] : _vm._e(),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }